
export const ACCOUNTING_DIRECTION = ['deposit', 'withdrawal'];

